<template>
  <div class="panel-header">
    
  </div>
</template>

<script>
export default {
  name: 'overview-header'
};
</script>

<style scoped>
</style>
